export default "__VITE_ASSET__7UjeS3X$__"